import { colorPaletteTheme as color } from './color';
import { textTheme } from './text';

export const bicycleColorTheme = {
  white: color.white,
  extraDarkGray: '#4D4D4D',
  lightRed: '#D64545',
  darkBlue: '#1461CC',
  lightYellow: '#FFE433',
  lightGreen: '#19803B',
  lightOrange: '#F26B0A',
  lightPink: '#F04D93',
  lightPurple: '#8D42A6',
} as const;

export const getBicycleColor = (bicycleNum: number) => {
  switch (bicycleNum) {
    case 1:
      return bicycleColorTheme.white;
    case 2:
      return bicycleColorTheme.extraDarkGray;
    case 3:
      return bicycleColorTheme.lightRed;
    case 4:
      return bicycleColorTheme.darkBlue;
    case 5:
      return bicycleColorTheme.lightYellow;
    case 6:
      return bicycleColorTheme.lightGreen;
    case 7:
      return bicycleColorTheme.lightOrange;
    case 8:
      return bicycleColorTheme.lightPink;
    case 9:
      return bicycleColorTheme.lightPurple;
    default:
      return bicycleColorTheme.white;
  }
};

export const getTextColor = (bicycleNum: number): string => {
  if (
    getBicycleColor(bicycleNum) === bicycleColorTheme.white ||
    getBicycleColor(bicycleNum) === bicycleColorTheme.lightYellow
  ) {
    return textTheme.default;
  }
  return textTheme.white;
};
